import Em from 'ember';
export default function (file) {
  return new Em.RSVP.Promise(function (resolve, reject) {
    let video = document.createElement('video');
    let reader = new FileReader();
    let onError = function (event) {
      reject({
        error: event,
        message: getErrorMessage(event)
      });
    };
    video.addEventListener('error', onError);
    video.addEventListener('loadeddata', () => {
      let thumbnailDataUrl = createThumbnailDataUrl(video);
      resolve({
        duration: video.duration,
        thumbnailDataUrl
      });
    });
    reader.addEventListener('error', onError);
    reader.addEventListener('load', () => {
      video.setAttribute('preload', 'auto');
      video.src = reader.result;
    });
    reader.readAsDataURL(file);
  });
  function createThumbnailDataUrl(video) {
    let canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    let context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpg');
  }
  function getErrorMessage(event) {
    let errorMessage = 'Failed to load video';
    if (isMediaDemuxerError(event)) {
      errorMessage += ' - Encoding error';
    }
    return errorMessage;
  }
  function isMediaDemuxerError(event) {
    return event && event.path && event.path.length && event.path[0].error && event.path[0].error.message === 'DEMUXER_ERROR_COULD_NOT_OPEN: FFmpegDemuxer: open context failed';
  }
}